import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"absolute":"","inset":"","app":"","height":"150","width":"auto","color":"grey lighten-5"}},[_c(VContainer,[_c(VRow,{staticClass:"text-caption",attrs:{"no-gutters":"","align":"center","justify":"center"}},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" "),_c(VBtn,{attrs:{"to":"/","text":"","x-small":""}},[_vm._v("monplanning")]),_vm._v(" | Tous droits réservés ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }